import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

// ---------------------------------------------------------------------------
// Sentry — no-op when VITE_SENTRY_DSN is unset (dev mode).
// We use a dynamic import so the bundle doesn't pay the cost of @sentry/react
// when Sentry isn't configured.
// ---------------------------------------------------------------------------
const sentryDsn = ((import.meta as any).env?.VITE_SENTRY_DSN || "").toString();
if (sentryDsn) {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: sentryDsn,
      tracesSampleRate: 0,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      environment:
        ((import.meta as any).env?.MODE as string | undefined) || "production",
    });
  }).catch((err) => {
    console.warn("Sentry init failed:", err);
  });
}

// Register service worker for PWA install + app-shell caching.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker-v2.js").catch((err) => {
      console.warn("SW registration failed:", err);
    });
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
